import React, { useContext } from 'react'
import { Redirect } from 'react-router-dom'
import { sessionContext } from '@marketing-milk/frontend'

export function GuestLayout({ children }: { children: any }) {
  const { user } = useContext(sessionContext)

  return !user ? children : <Redirect to="/dashboard" />
}
